// clear-cart.js

function clearCartAndRedirect() {
  // Send AJAX request to clear the cart
  fetch('/cart/clear.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    }
  })
  .then(response => {
    if (response.ok) {
      // Cart cleared successfully, redirect to home page
      window.location.href = '/';
    } else {
      // Handle error if needed
      console.error('Error clearing cart');
    }
  })
  .catch(error => {
    console.error('Error clearing cart:', error);
  });
}
